import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';

import { isEmpty } from 'lodash';
import dynamic from 'next/dynamic';
import { colors, fontSize } from '../../constants/styleConstants';
import NextLink from '../NextLink';
const Title = dynamic(() => import('../Title'));

const useStyles = makeStyles()(theme => ({
  workInfo: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'baseline',
      flexWrap: 'wrap',
    },
  },
  nextRow: {
    flexBasis: '100%',
  },
  link: {
    fontSize: fontSize.basic,
    fontWeight: 'bold',
    color: `${colors.blueChip} !important`,
  },
  boldTitle: {
    fontSize: fontSize.basic,
    color: colors.darkText,
    fontWeight: 'bold',
  },
  lightTitle: {
    fontSize: fontSize.basic,
    color: colors.lightTitle,
    fontWeight: 'bold',
  },
  workName: {
    fontSize: fontSize.medium,
    color: colors.grey3,
    opacity: '0.7',
  },
  composer: {
    fontStyle: 'italic',
    color: colors.grey3,
    fontSize: fontSize.medium,
    marginRight: '0 !important',
  },
  tagName: {
    color: colors.grey16,
    fontSize: fontSize.smallTitle,
    marginLeft: 5,
    lineHeight: '14px',
    borderRadius: '12px',
    background: colors.grey3Opacity20,
    padding: '4px 5px',
    fontFamily: 'RobotoBold',
  },
}));

const WorkInfoBlock = ({
  work,
  composerNames,
  isMultiWorks,
  production,
  className,
  linkProps,
  expanded,
  hasCustomName,
  tagName,
}) => {
  const { classes, cx } = useStyles();
  const name = work?.original_name || work?.name || '';

  return (
    <div className={cx(classes.workInfo, className, { [classes.nextRow]: isMultiWorks && hasCustomName })}>
      {linkProps ? (
        <NextLink {...linkProps} stopPropagation>
          <Title
            size="big"
            weight="bold"
            className={cx({
              [classes.link]: expanded,
            })}
          >
            {name}
          </Title>
        </NextLink>
      ) : (
        <span className={cx(isEmpty(production) ? classes.boldTitle : classes.lightTitle)}>{name}</span>
      )}
      {work?.name && work?.name !== name && <span className={classes.workName}>{`\u00A0(${work?.name})`}</span>}
      {composerNames && <span className={classes.composer}>{`, ${composerNames}`}</span>}
      {tagName && <span className={classes.tagName}>{tagName}</span>}
      {isMultiWorks && !hasCustomName && <span>,&nbsp;&nbsp;</span>}
    </div>
  );
};

WorkInfoBlock.propTypes = {
  work: PropTypes.object,
  composerNames: PropTypes.string,
  isMultiWorks: PropTypes.bool,
  hasCustomName: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  production: PropTypes.string,
  className: PropTypes.string,
};

export default WorkInfoBlock;
